// @flow
import React, { useState } from "react";
import TextBox from "../text-box";
import TextBlock from "../text-block";
import DateTimePicker from "../../components/date-time-picker";
import "./styles.css";
import FAB from "../fab";
import { Accordion, AccordionPanel } from "../accordion/accordian";
import EventInfo from "../../models/event-info";
import FAQEditor from "../faq-editor";


type PropsType = { saveEventInfo: Object => void, eventInfo: Object, faqs: Object, saveFAQ: Object => void, deleteFAQ: Object => void };

export const Settings = ({ saveEventInfo, eventInfo = {}, faqs = {}, saveFAQ, deleteFAQ }: PropsType) => {
    const [myEventInfo, setMyEventInfo] = useState(EventInfo.create(eventInfo));
    const [isDirty, setIsDirty] = useState(false);
    const updateEvent = (key: string) => (value) => {
        setMyEventInfo({ ...myEventInfo, [key]: value });
        setIsDirty(true);
    };


    return (
        <div className={ "settings" }>
            <Accordion id={ "greenUpDay" } openExclusive={ false }>
                <AccordionPanel id={ "eventSettings" } title={ "Event Settings" }>
                    <header className={ "settings-screen--header-control" }>
                        <FAB
                            className={ "faq-editor--header-add-button" }
                            icon={ "faSave" }
                            label={ "SAVE" }
                            onClick={ () => saveEventInfo(myEventInfo) }
                            disabled={ !isDirty }/>
                    </header>
                    <TextBox
                        labelText={ "Event Name" }
                        onChange={ updateEvent("name") }
                        value={ myEventInfo.name || "" }
                    />
                    <TextBlock
                        labelText={ "Event Description" }
                        onChange={ updateEvent("description") }
                        value={ myEventInfo.description }
                    />
                    <DateTimePicker
                        labelText="Event Date"
                        onChange={ updateEvent("eventDate") }
                        type={ "date" }
                        value={ myEventInfo.eventDate }/>
                    <DateTimePicker
                        labelText="Event Window Start"
                        onChange={ updateEvent("eventWindowStart") }
                        type={ "date" }
                        value={ myEventInfo.eventWindowStart }
                    />
                    <DateTimePicker
                        labelText="Event Window End"
                        onChange={ updateEvent("eventWindowEnd") }
                        type={ "date" }
                        value={ myEventInfo.eventWindowEnd }
                    />
                </AccordionPanel>
                <AccordionPanel id={ "faqs" } title={ "FAQs" }>
                    <FAQEditor faqs={ faqs } onDelete={ deleteFAQ } onSave={ saveFAQ }/>
                </AccordionPanel>
            </Accordion>
        </div>
    );

};
